<h2 mat-dialog-title>{{ inputData().title }}</h2>

<mat-dialog-content>

    <div class="p-4">

        <form>

            <div class="mce-form-section">

                <div class="mce-form-field-group">

                    <div>
                        <mat-form-field>
                            <mat-label>fault current</mat-label>
                            <input matInput type="number" placeholder="fault current"
                                   [formField]="form.i" />
                            <span matSuffix>kA</span>
                            @for (error of form.i().errors(); track error.kind ) {
                            <mat-error> {{ error.message }} </mat-error> }
                        </mat-form-field>
                    </div>

                    @if(!inputData().isDC){
                        <div>
                            <app-power-factor [form]="form.pf"></app-power-factor>
                        </div>
                    }

                </div>

            </div>
        </form>

    </div>
</mat-dialog-content>

<mat-dialog-actions>

    <div class="w-full">
        <mce-save-cancel [config]="saveCancelConfig()"
                         (action)="onSaveCancelAction($event)">
        </mce-save-cancel>
    </div>


</mat-dialog-actions>

